import { Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  DiscountIcon3,
  SpecialEventLargeIcon,
} from "../../assets/designedPickedIcons";
import dummyResturant1 from "../../assets/place-dummy-1.png";
import dummyResturant2 from "../../assets/resturant-dummy2.png";
import { showInFullScreen } from "../specials/FullScreenView";
import { shallowEqual, useSelector } from "react-redux";
import moment from "moment";

const ResturantSpecialEvent = () => {
  const allEvents = useSelector((s) => s?.ALLEventsData ?? [], shallowEqual);
  const placeDetails = useSelector((s) => s?.placeDetails ?? {}, shallowEqual);

  const specialEvent = allEvents?.specialEvents?.find(
    (i) => i?.place == placeDetails?._id
  );
  const availability = specialEvent?.availability;
  console.log("special event", specialEvent, "all events", allEvents);

  if(specialEvent)
  return (
    <div
      className=" position-relative"
      style={{
        minHeight: "70vh",
      }}
    >
      <div
        className="resturant-detail-div position-relative  "
        style={{ zIndex: 3 }}
      >
        <h2
          style={{ transform: "translateX(-2%)" }}
          className="f-6 d-flex text-white align-items-center m-0  figma-shadowed-black-text justify-content-center gap-1 text-center"
        >
          <SpecialEventLargeIcon />
          Special Event
        </h2>
        <h3
          style={{ letterSpacing: "5px" }}
          className="f-5 color-primary-brown-1  mt-3 mb-4  text-center"
        >
          {specialEvent?.title}
        </h3>
        <div className="" style={{ borderRadius: "6px" }}>
          <Row
            className="g-3"
            onClick={(e) => showInFullScreen(e?.target, specialEvent?.photos)}
          >
            <Col md={6}>
              <Row className="g-3">
                <Col md={12}>
                  <img
                    src={specialEvent?.photos?.[0]}
                    height={150}
                    style={{
                      borderRadius: "7px",
                      border: "2px solid rgba(202, 149, 69, 1)",
                    }}
                    className="full-width clickable-photo object-fit-cover"
                  />
                </Col>
                <Col md={6}>
                  <img
                    src={specialEvent?.photos?.[1]}
                    height={150}
                    style={{
                      borderRadius: "7px",
                      border: "2px solid rgba(202, 149, 69, 1)",
                    }}
                    className="full-width clickable-photo object-fit-cover"
                  />
                </Col>
                <Col md={6}>
                  <img
                    src={specialEvent?.photos?.[2]}
                    height={150}
                    style={{
                      borderRadius: "7px",
                      border: "2px solid rgba(202, 149, 69, 1)",
                    }}
                    className="full-width clickable-photo object-fit-cover"
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="g-3">
                <Col md={6}>
                  <img
                    src={specialEvent?.photos?.[3]}
                    height={316}
                    style={{
                      borderRadius: "7px",
                      border: "2px solid rgba(202, 149, 69, 1)",
                    }}
                    className="full-width clickable-photo object-fit-cover"
                  />
                </Col>
                <Col md={6}>
                  <img
                    src={specialEvent?.photos?.[4]}
                    height={150}
                    style={{
                      borderRadius: "7px",
                      border: "2px solid rgba(202, 149, 69, 1)",
                    }}
                    className="full-width clickable-photo mb-3 object-fit-cover"
                  />

                  <img
                    src={specialEvent?.photos?.[5]}
                    height={150}
                    style={{
                      borderRadius: "7px",
                      border: "2px solid rgba(202, 149, 69, 1)",
                    }}
                    className="full-width clickable-photo object-fit-cover"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <h3 className="color-primary-blue mt-4 mb-3 text-center figma-shadowed-black-text  f-6">
          {specialEvent?.name}
        </h3>
        

        <Row className="g-md-0 gy-2 justify-content-center">
          <h5 className="f-4 my-3" style={{ lineHeight: "29.97px" }}>
            {specialEvent?.description}
          </h5>
          <Col md={6}>
          <h5 className="mb-2">
               From Date :{" "}
                <span className="f-6 color-primary-blue">
                  {moment(specialEvent?.startDate)?.format("ddd , DD-MM-YYYY")}
                </span>
              </h5>
              <h5 className="mb-2">
               To Date :{" "}
                <span className="f-6 color-primary-blue">
                  {moment(specialEvent?.endDate)?.format("ddd , DD-MM-YYYY")}
                </span>
              </h5>
               
               <h5 className="my-3">Availability : </h5>
            {availability?.map((item) => {
              let splittedStartTime=item?.openTime?.split(":");
              let splittedEndTime=item?.closeTime?.split(":");
              let formattedStartTime = new Date()?.setHours(
               splittedStartTime?.[0],splittedStartTime?.[1] 
              );
              let formattedEndTime = new Date()?.setHours(
                splittedEndTime?.[0],splittedEndTime?.[1]
              );

              return (
               <>
                <h5 className="mb-2">
               Day {" "}
                <span className="f-6 color-primary-blue">
                  {item?.day}
                </span>
              </h5>
                <h5 className="m-0">
                  From :{" "}
                  <span className="f-6 color-primary-blue">
                    {moment(formattedStartTime)?.format("hh:mm a")} to{" "}
                    {moment(formattedEndTime)?.format("hh:mm a")}
                  </span>
                </h5></>
              );
            })}
          </Col>
          <Col md={6} className="d-flex justify-content-end align-items-end">
            <div
              className="py-1 px-3 outer-transparent-shadow d-flex align-items-center  gap-md-3 gap-1"
              style={{
                borderRadius: "13.95px",
                background: "rgba(255, 255, 255, 0.7)",
              }}
            >
              <div className="d-flex items-center">
                <DiscountIcon3 color={"rgba(18, 118, 239, 1)"} />
                <DiscountIcon3 color={"rgba(254, 48, 48, 1)"} />
                <DiscountIcon3 color={"rgba(56, 138, 43, 1)"} />
              </div>
              <h5 className="m-0" style={{ letterSpacing: "0.31rem" }}>
                Available Discount
              </h5>
            </div>
          </Col>
          <Col md={7} style={{ marginTop: "2.4rem" }}>
            <Button className="standard-rounded-btn border-none full-width  py-3">
              Book Reservation
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
  else return <h5>No special event related to this place</h5>
};

export default ResturantSpecialEvent;
